import { enableDragScroll } from '../../tools/helpers';

class ProjectTeaserSlider {
  constructor(options = {}) {
    this.element = options.element;
    this.sliderWrapper = this.element.querySelector('.project-teaser-slider__slider-wrapper');
  }

  init() {
    if (!this.sliderWrapper) {
      return;
    }

    enableDragScroll(this.sliderWrapper);
  }
}

export default ProjectTeaserSlider;
